import axios from "axios";
// Yan etki: global axios'a vekalet bağlamı başlığı/412 yakalayıcısı bağlanır.
import "config/vekaletBaglami";
const isReactSnap = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
const API_BASE_URL = isReactSnap ? "https://renix.app" : "";

axios.defaults.withCredentials = true;

// CSRF: the server issues a JS-readable XSRF-TOKEN cookie and expects it echoed
// back on every unsafe request. Axios does this itself once the names are set.
// Stated explicitly rather than relying on the library defaults, because the
// backend rejects on mismatch (see middleware/csrf.py).
axios.defaults.xsrfCookieName = "XSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";

/** Current CSRF token, for the one native <form> post that axios can't cover. */
export function getCsrfToken() {
  const match = document.cookie.match(/(?:^|;\s*)XSRF-TOKEN=([^;]*)/);
  return match ? decodeURIComponent(match[1]) : "";
}

export default API_BASE_URL;
